"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import smarterBrighter from "@/assets/smarter-brighter.png";
import quickatooLogoStacked from "@/assets/quickatoo-logo-stacked.png";

interface TestimonialProps extends React.HTMLAttributes<HTMLDivElement> {
  quote: string;
  secondaryQuote?: string;
  highlightedText?: string;
}

export const Testimonial = React.forwardRef<HTMLDivElement, TestimonialProps>(
  ({ className, quote, secondaryQuote, highlightedText, ...props }, ref) => {
    const formattedQuote = highlightedText
      ? quote.replace(
          highlightedText,
          `<strong class="font-semibold text-white">${highlightedText}</strong>`
        )
      : quote;

    return (
      <div ref={ref} className={cn("py-12 px-4 md:px-8", className)} {...props}>
        <div className="max-w-screen-xl mx-auto">
          <div className="rounded-3xl bg-quickatoo-purple px-6 py-16 md:px-16 md:py-20 flex flex-col items-center text-center">
            <img
              src={quickatooLogoStacked}
              alt="Quickatoo Painters Estimator"
              className="h-20 md:h-24 w-auto mb-10"
            />
            <p
              className="max-w-4xl text-balance text-xl md:text-2xl lg:text-3xl text-white leading-relaxed"
              dangerouslySetInnerHTML={{ __html: formattedQuote }}
            />
            {secondaryQuote && (
              <p className="mt-8 max-w-4xl text-balance text-xl md:text-2xl lg:text-3xl text-white leading-relaxed">
                {secondaryQuote}
              </p>
            )}
            <img
              src={smarterBrighter}
              alt="Smarter. Brighter."
              className="mt-12 h-9 md:h-11 w-auto"
            />
          </div>
        </div>
      </div>
    );
  }
);

Testimonial.displayName = "Testimonial";
